import { VehicleType } from '@repo/shared'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { VehicleDetailPage } from '@/features/vehicles/components/vehicle-detail-page/vehicle-detail-page'

const detailSearchParams = z.object({
  type: z.nativeEnum(VehicleType).optional().default(VehicleType.Truck),
})

export const Route = createFileRoute('/dashboard/vehicles/$vehicleId/')({
  validateSearch: detailSearchParams,
  component: VehicleDetailRoute,
})

function VehicleDetailRoute() {
  const { vehicleId } = Route.useParams()
  const { type } = Route.useSearch()

  return (
    <VehicleDetailPage
      vehicleId={Number(vehicleId)}
      vehicleType={type === VehicleType.Trailer ? 'trailer' : 'truck'}
    />
  )
}
